import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_PROVIDER_URL = `${BASE_URL}api/providers/`;

const ProviderService = () => ({

    getAllProviders: async () => {
        const { data } = await axios.get(`${BASE_PROVIDER_URL}`);
        return data;
    }
});

export default ProviderService;